// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox{cursor:pointer;font-size:24px}.bulkslider{bottom:0;background:#fff;color:#777;position:fixed;left:0;width:100%;height:220px;transition:bottom 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);box-sizing:border-box;z-index:1000;box-shadow:0 -3px 3px rgba(0,0,0,.1);padding-top:40px;padding-left:25px;padding-right:25px}", ""]);
// Exports
module.exports = exports;
